import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['actionplans', 'origins'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actionplans/origins`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'actionplans/origins',
    store,
  });
  basePlugin.onInit(() => store.dispatch('actionplans/origins/initItems'));
};
